import { getPreloadedState } from '../../get-preloaded-state';

export const getChatApiHost = () => {
    const preloadedState = getPreloadedState();
    const messengerApiHost = preloadedState.config?.messengerApiHost ?? 'https://api.messenger.yandex.ru';
    return messengerApiHost;
};
